'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRecentLogins = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _flatMap = require('lodash/flatMap');

var _flatMap2 = _interopRequireDefault(_flatMap);

var _config = require('../Services/config');

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var camelize = function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
    return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '');
};

var getUserRecentLogins = exports.getUserRecentLogins = function getUserRecentLogins(accessToken) {
  return (0, _config.getMcpApps)().then(function (mcpApps) {
    return fetch('https://marketplace-service.mex.cimpress.io/v1/user/logins', {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken
      })
    }).then(function (response) {
      return response.json().then(function (logins) {
        var loginList = Object.keys(logins).map(function (clientId) {
          return {
            clientId: clientId,
            count: logins[clientId]
          };
        });

        if (!loginList.length) {
          return null;
        }

        return loginList.map(function (_ref) {
          var clientId = _ref.clientId,
              count = _ref.count;
          return _extends({
            clientId: clientId,
            count: count
          }, (0, _lodash2.default)(mcpApps, function (mcpApp) {
            return mcpApp.clientId === clientId;
          }) || {});
        }).filter(function (login) {
          return login.link && login.id;
        }).sort(function (a, b) {
          return b.count - a.count;
        });
      });
    });
  });
};